/**
 * Whether Notifications v2 draws hairline borders between rows, under the
 * section headers and above the loading footer, on every platform. This is a
 * static flag while the design settles: set it to `false` to go back to rows
 * without borders.
 */
export const SHOW_ROW_BORDERS = true
